<div class="login">
  <div class="login__header">
    <h2 class="login__header__title">Login to KEYS<span>7</span></h2>
    <div class="login__header__link">
      <span>Don't have an account?</span>
      <a routerLink="/register"> Register</a>
    </div>
  </div>

  <div class="login__qr">
    <p class="login__qr-text">Continue with your phone.</p>
    <img
      class="login__qr-code"
      src="/assets/images/login/QR_code.png"
      alt="QR Code"
    />
  </div>

  <nz-divider nzText="or" class="login__divider"></nz-divider>

  <div class="login__social-buttons">
    <!-- Discord -->
    <app-discord-signin
      (buttonClick)="loginClick()"
      text="Login with Discord"
      [pluginName]="pluginName"
      page="login"
    ></app-discord-signin>

    <!-- Microsoft -->
    <app-microsoft-signin
      (buttonClick)="loginClick()"
      text="Login with Xbox"
      [pluginName]="pluginName"
      (token)="onMicrosoftToken($event)"
    ></app-microsoft-signin>

    <!-- Google -->
    <app-google-signin
      (buttonClick)="loginClick()"
      text="Login with Google"
      [pluginName]="pluginName"
      (token)="onGoogleToken($event)"
    ></app-google-signin>

    <!-- Facebook -->
    <app-facebook-signin
      (buttonClick)="loginClick()"
      text="Login with Facebook"
      [pluginName]="pluginName"
      (token)="onFacebookToken($event)"
    ></app-facebook-signin>

    <!-- Apple -->
    <app-apple-signin
      (buttonClick)="loginClick()"
      text="Login with Apple"
      [pluginName]="pluginName"
      (token)="onAppleToken($event)"
      page="login"
    ></app-apple-signin>
  </div>

  <nz-divider nzText="or" class="login__divider"></nz-divider>

  <form
    nz-form
    [formGroup]="validateForm"
    (ngSubmit)="submitForm()"
    class="login__form"
    autocomplete="off"
  >
    <div class="login__form-item">
      <label class="login__form-item-label">Email</label>
      <nz-input-group>
        <input
          nzType="primary"
          nz-input
          placeholder="Email"
          formControlName="email"
          class="login__input"
          autocomplete="new-email"
          name="email"
        />
      </nz-input-group>
      <div
        *ngIf="f['email']?.errors?.['required'] && f['email']?.touched"
        class="login__form__error"
      >
        Email is required
      </div>
      <div
        *ngIf="f['email']?.errors?.['email'] && f['email']?.touched"
        class="login__form__error"
      >
        Please enter a valid email
      </div>
    </div>

    <div class="login__form-item">
      <label class="login__form-item-label">Password</label>
      <nz-input-group>
        <input
          nzType="primary"
          nz-input
          placeholder="Password"
          formControlName="password"
          type="password"
          class="login__input"
          autocomplete="new-password"
          name="password"
        />
      </nz-input-group>
      <div
        *ngIf="f['password']?.invalid && f['password']?.touched"
        class="login__form__error"
      >
        Password is required
      </div>
    </div>

    <div class="login__options">
      <label class="login__options__remember">
        <label nz-checkbox>Remember me</label>
      </label>
      <a class="login__options__forgot-password"> Forgot password? </a>
    </div>

    <button nz-button nzType="primary" type="submit" class="login__submit">
      Next
    </button>
    <button
      nz-button
      nzType="primary"
      routerLink="/register"
      class="login__create-account beta"
    >
      Create an Account
    </button>
  </form>
</div>
